export type AuthToken = {
  token: string
  expiresAt: number
}

const TOKEN_KEY = 'auth_token'

export function saveToken(token: string, keepUserLoggedIn: boolean) {  
  const twoWeeksMs = 14 * 24 * 60 * 60 * 1000
  const halfAnHourMs = 30 * 60 * 1000
  const expireMs = keepUserLoggedIn ? twoWeeksMs : halfAnHourMs

  const tokenData: AuthToken = {
    token,
    expiresAt: Date.now() + expireMs
  }

  localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData))
}

export function loadToken() {
  const tokenData = localStorage.getItem(TOKEN_KEY)
  
  if (tokenData) {
    const parsedTokenData = JSON.parse(tokenData)
    if (Date.now() < parsedTokenData.expiresAt) {      
      return parsedTokenData.token
    } else {
      // token expired
      return null
    }
  } else {
    // token data doesn't exist
    return null
  }
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
}